export class mdlSadadBillerReq {
    public RegNo: string;
    public Token: string;
    public ProductCode: string;
    public ProposalNo: string;
    public InsuredIdNo: string;
    public Lang: string;
}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/mdlSadadBillerReq.ts